var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-image"},[_c('div',{staticClass:"slider-image__image",style:(_vm.style)}),(_vm.$slots.overlay)?_c('div',{staticClass:"slider__overlay-wrapper"},[_vm._t("overlay")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }